import React from "react";

import {
  HvRadio,
  HvRadioGroup,
  HvRadioGroupProps,
  HvToggleButton,
  HvTooltip,
  HvTypography,
} from "@hitachivantara/uikit-react-core";
import { Preview, PreviewOff } from "@hitachivantara/uikit-react-icons";

import { NotificationTemplate } from "lib/api";

import useStyles from "./styles";

export interface TemplateSelectorProps
  extends Omit<HvRadioGroupProps, "children"> {
  templateType: string;
  previewIsVisible: boolean;
  value?: NotificationTemplate;
  onChange: (event: unknown, value?: NotificationTemplate) => void;
  templates?: NotificationTemplate[];
  togglePreview: (visible: boolean) => void;
  hidePreviewTooltip: string;
  showPreviewTooltip: string;
  showPreviewAriaLabel: string;
}

const TemplateSelector: React.FC<TemplateSelectorProps> = ({
  previewIsVisible,
  value,
  onChange,
  togglePreview,
  templates,
  label,
  hidePreviewTooltip,
  showPreviewTooltip,
  showPreviewAriaLabel,
}) => {
  const classes = useStyles();
  return (
    <>
      {(templates?.length ?? 0) <= 1 ? (
        <> </>
      ) : (
        <HvRadioGroup
          className={classes.root}
          onChange={onChange}
          orientation="horizontal"
          label={label}
          required
          value={value}
        >
          {templates &&
            templates.map((template: NotificationTemplate | undefined) => {
              const selectedAndOpen = previewIsVisible && value === template;
              const tooltip = (
                <HvTypography>
                  {selectedAndOpen ? hidePreviewTooltip : showPreviewTooltip}
                </HvTypography>
              );
              return (
                <HvRadio
                  key={template?.id}
                  label={
                    <span>
                      {template?.name}
                      <HvTooltip title={tooltip}>
                        <HvToggleButton
                          className={classes.previewToggle}
                          aria-label={showPreviewAriaLabel}
                          selected={selectedAndOpen}
                          onClick={(evt) => {
                            if (template !== value) {
                              onChange(evt, template);
                            }
                            if (template === value || !previewIsVisible) {
                              togglePreview(!previewIsVisible);
                            }
                          }}
                        >
                          {selectedAndOpen ? <Preview /> : <PreviewOff />}
                        </HvToggleButton>
                      </HvTooltip>
                    </span>
                  }
                  value={template}
                />
              );
            })}
        </HvRadioGroup>
      )}
    </>
  );
};

export default TemplateSelector;
